var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_440_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9718 55.878C55.1598 55.878 59.3655 51.6723 59.3655 46.4843C59.3655 41.2963 55.1598 37.0906 49.9718 37.0906C44.7838 37.0906 40.5781 41.2963 40.5781 46.4843C40.5781 51.6723 44.7838 55.878 49.9718 55.878Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1464 35.2481C66.6685 35.2481 70.3343 31.5822 70.3343 27.0602C70.3343 22.5381 66.6685 18.8723 62.1464 18.8723C57.6244 18.8723 53.9585 22.5381 53.9585 27.0602C53.9585 31.5822 57.6244 35.2481 62.1464 35.2481Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9106 35.2481C42.4326 35.2481 46.0985 31.5822 46.0985 27.0602C46.0985 22.5381 42.4326 18.8723 37.9106 18.8723C33.3885 18.8723 29.7227 22.5381 29.7227 27.0602C29.7227 31.5822 33.3885 35.2481 37.9106 35.2481Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7706 53.0292C30.3755 53.0292 34.1085 49.2961 34.1085 44.6912C34.1085 40.0863 30.3755 36.3533 25.7706 36.3533C21.1656 36.3533 17.4326 40.0863 17.4326 44.6912C17.4326 49.2961 21.1656 53.0292 25.7706 53.0292Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0069 53.0292C68.1244 53.1078 63.2812 57.3436 62.0718 62.8858C63.2611 64.9387 63.9417 67.3155 63.9417 69.846V76.1529C64.0643 76.1712 64.1906 76.184 64.3187 76.184H84.0319C85.4352 76.184 86.5733 75.046 86.5733 73.6426V65.4254C86.5733 58.5512 80.9031 52.9358 74.0069 53.0292Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0037 70.0289C36.0037 67.4454 36.6989 65.0118 37.9102 62.9114C36.7282 57.2338 31.6343 52.9468 25.6018 53.0273C18.7935 53.1188 13.3721 58.7781 13.3721 65.5864V73.6407C13.3721 75.0441 14.5101 76.1822 15.9135 76.1822H35.6267C35.7548 76.1822 35.8811 76.1694 36.0037 76.1511V70.0271V70.0289Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1081 44.6912C34.1081 49.2965 30.3755 53.0291 25.7701 53.0291C25.7591 53.0291 25.7463 53.0291 25.7354 53.0291C31.7093 53.0145 36.7374 57.2777 37.9102 62.9132C37.9102 62.9132 37.9102 62.915 37.9084 62.9168C40.2943 58.7799 44.6947 55.9475 49.7831 55.8798C49.8453 55.8798 49.9075 55.8798 49.9679 55.8798C44.7807 55.878 40.5779 51.6733 40.5779 46.4861C40.5779 42.8267 42.6711 39.6595 45.723 38.1079C43.5658 36.2929 40.7773 35.2078 37.7437 35.2481C35.0046 35.2847 32.4943 36.2416 30.4834 37.8152C32.6718 39.3192 34.1062 41.8368 34.1062 44.6912H34.1081Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3676 46.4843C59.3676 51.6715 55.1647 55.8762 49.9775 55.878C55.13 55.878 59.653 58.7067 62.0737 62.8876C62.0737 62.8876 62.0737 62.8876 62.0737 62.8858C63.2831 57.3436 68.1282 53.1079 74.0088 53.0292C74.115 53.0292 74.2193 53.031 74.3236 53.0328V53.0255C74.2742 53.0255 74.2266 53.0292 74.1772 53.0292C69.5718 53.0292 65.8392 49.2966 65.8392 44.6912C65.8392 41.804 67.3066 39.2607 69.5352 37.764C67.442 36.1575 64.8201 35.2097 61.984 35.2481C59.0529 35.2866 56.3852 36.3771 54.3103 38.1537C57.3146 39.7218 59.3676 42.8634 59.3676 46.4862V46.4843Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1737 81.9677H61.0762C62.6571 81.9677 63.9397 80.6851 63.9397 79.1042V69.8459C63.9397 62.1008 57.5504 55.7755 49.7814 55.878C42.1113 55.9805 36.002 62.357 36.002 70.0289V79.1042C36.002 80.6851 37.2846 81.9677 38.8654 81.9677H46.7679",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9441 41.6686C80.7329 38.5581 77.712 36.3551 74.1734 36.3551C69.568 36.3551 65.8354 40.0877 65.8354 44.6931C65.8354 49.2984 69.568 53.031 74.1734 53.031C77.5748 53.031 80.4987 50.9927 81.7959 48.0725",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_1104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.9454,
    height: 65.84,
    fill: "white",
    transform: "translate(12 17.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClients);
export default __webpack_public_path__ + "static/media/icon_clients.389f64cace3b70903a41b2b0c96887a1.svg";
export { ForwardRef as ReactComponent };